// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".survey-page.slide__x01-enter .support-expand-btn[data-v-15d36bd1],.survey-page.slide__x01-enter-active .support-expand-btn[data-v-15d36bd1],.survey-page.slide__x01-leave-to .support-expand-btn[data-v-15d36bd1],.survey-page.slide__x10-enter .support-expand-btn[data-v-15d36bd1],.survey-page.slide__x10-leave-active .support-expand-btn[data-v-15d36bd1],.survey-page.slide__x10-leave-to .support-expand-btn[data-v-15d36bd1]{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
